import { render, staticRenderFns } from "./MangoPriceAssignmentDemo.vue?vue&type=template&id=4bcb56a5&scoped=true"
import script from "./MangoPriceAssignmentDemo.vue?vue&type=script&lang=js"
export * from "./MangoPriceAssignmentDemo.vue?vue&type=script&lang=js"
import style0 from "./MangoPriceAssignmentDemo.vue?vue&type=style&index=0&id=4bcb56a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb56a5",
  null
  
)

export default component.exports